export function documentEditorWindowUrl(
  conversationId: string,
  artifactId: string,
  pathname: string,
) {
  const prefix = pathname.startsWith("/projects/") ? "/projects/c/" : "/c/";
  const query = new URLSearchParams({
    document: artifactId,
    editorWindow: "1",
  });
  return `${prefix}${encodeURIComponent(conversationId)}?${query}`;
}
